export const link = {
    py: 1,
    display: 'block',
    color: 'sidebar.navGroup',
    textDecoration: 'none',
    fontFamily: '\'Rubik\', sans-serif !important',
    fontSize: 2,
    fontWeight: 300,
    position: 'relative',
    '&.active': {
        color: 'sidebar.navLinkActive',
        fontWeight: 400
    },
    '&.active::before': {
        content: '""',
        position: 'absolute',
        display: 'block',
        top: 0,
        left: -4,
        bottom: 0,
        backgroundColor: 'sidebar.navLinkActive',
        transition: 'width 200ms ease 0s',
        width: '4px'
    },
}

export const smallLink = {
    ...link,
    ml: 2,
    fontSize: 1,
    position: 'relative',
    color: 'sidebar.tocLink',
    '&.active': {
        color: 'sidebar.navLinkActive',
        fontWeight: 400
    },
    '&.active::before': {
        content: '""'
    },
}